import React from 'react';
import { LogOut, User as UserIcon } from 'lucide-react';
import { User } from '../hooks/useAuth';
import Logo from './Logo';

interface UserHeaderProps {
  user: User;
  onLogout: () => void;
}

const UserHeader: React.FC<UserHeaderProps> = ({ user, onLogout }) => {
  return (
    <header className="bg-hpe-dark-surface border-b border-hpe-dark-border">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <Logo className="w-8 h-8" size={32} />
            <span className="text-lg font-bold">OpenAPI to MCP</span>
          </div>

          {/* User Menu */}
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-3">
              {user.avatar ? (
                <img 
                  src={user.avatar} 
                  alt={user.name}
                  className="w-8 h-8 rounded-full"
                />
              ) : (
                <div className="w-8 h-8 bg-hpe-gray-600 rounded-full flex items-center justify-center">
                  <UserIcon className="w-4 h-4 text-hpe-gray-300" />
                </div>
              )}
              <div className="text-sm">
                <div className="font-medium">{user.name}</div>
                <div className="text-hpe-gray-400 text-xs">{user.email}</div>
              </div>
            </div>
            
            <button
              onClick={(e) => {
                e.preventDefault();
                console.log('Sign out button clicked');
                onLogout();
              }}
              className="flex items-center gap-2 px-3 py-2 text-hpe-gray-400 hover:text-hpe-primary hover:bg-hpe-dark-card rounded-lg transition-colors"
              title="Sign out"
            >
              <LogOut className="w-4 h-4" />
              <span className="text-sm">Sign out</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default UserHeader;